var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { underscoreKeys } from '../util';
/**
 * AWS Lambda Function APIを叩くためのclient
 * @class
 */
export class LambdaFunctionClient {
    constructor(baseURL) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialReferrer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axios.create({
            baseURL,
            timeout: 2000, // 2000ms = 2sec
        });
        this.axios.interceptors.request.use((req) => {
            req.data = underscoreKeys(req.data);
            return req;
        });
        this.axios.interceptors.response.use((res) => {
            return res;
        }, (error) => {
            this.onError(error);
        });
    }
    onError(error) {
        const e = error;
        if (!e.response) {
            throw e;
        }
        switch (e.response.status) {
            // 401のみ許容している
            case 401:
                break;
        }
        throw e;
    }
    /**
     * Facebook Conversion APIにデータを送信
     * @param params
     */
    postConversionToFB(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axios.post('/pixel_event', params).catch(() => {
                // 稀にリクエストエラーになります。確実な再現不可能。分析用なのでエラーハンドリングしなくてok
                return null;
            });
        });
    }
}
